import reducer, { initialState } from '../../../reducers/userInfo/updatePhoneFlow';
import * as actions from '../../../actions/userInfo/updatePhoneFlow';


const fn = { reducer, initialState, actions };
export default fn;
 
